// Library Imports
import React from 'react'
// Component Imports
import PageBanner from '../../components/banner/PageBanner'
import PendingDirectoryListings from './PendingDirectoryListings'
import SearchDirectoryListings from './SearchDirectoryListings'

function EmployeeDirectoryUpdates() {
  
  return (
    <div className='employeedirectoryupdates-page-container'>
      <PageBanner pageName='Employee Directory Updates' />
      <PendingDirectoryListings/>
      <SearchDirectoryListings/>
    </div>
  )
}

export default EmployeeDirectoryUpdates